export enum RecordType {
  EMAIL_INCOME = 'EMAIL_INCOME',
  EMAIL_OUTCOME = 'EMAIL_OUTCOME',
  PHONE_COMMUNICATION = 'PHONE_COMMUNICATION',
  PERSONAL_MEETING = 'PERSONAL_MEETING',
  COMMENT = 'COMMENT'
}
